import Blue from "~/core";
import { addEvents, createElement } from "~/utils";

new Blue({
  name: "Blue Form",
  selector: ".blue-form",
  setup(blueform) {
    const container = blueform;

    const resizeTextarea = t => {
      const style = getComputedStyle(t);
      const border = parseInt(style.borderTop) + parseInt(style.borderBottom);
      t.style.height = '';
  
      t.style.height = `${t.scrollHeight + border}px`;
    };
  
    const formatSelect = s => {
      if (s.value.trim()) s.classList.remove('is-placeholder');
      else s.classList.add('is-placeholder');
    };
  
    const tooltips = i => {
      const tip = createElement({
        tag: 'small',
        attributes: { class: 'blue-form__tooltip' },
        html: `<span>${i.getAttribute('title')}</span>`,
      });
      i.closest('.form-field').insertAdjacentElement('afterbegin', tip);
    };
  
    const triage = e => {
      if (e.target.matches('textarea')) resizeTextarea(e.target);
      if (e.target.matches('select')) formatSelect(e.target);
    };
  
    const formEl = container.querySelector('form');
    if (formEl && container.querySelector('.required-field-red-star')) {
      const note = document.createElement('p');
      note.className = 'form__required-note';
      note.innerHTML = '<span aria-hidden="true">*</span> indicates a required field';
      formEl.insertAdjacentElement('afterbegin', note);
    }

    // container.querySelectorAll('input[title]').forEach(tooltips); // TODO: re-enable once tooltip styling is finalized
    container.querySelectorAll('select').forEach(formatSelect);
    container.querySelectorAll('textarea').forEach(resizeTextarea);
  
    this.$addEvents(container, 'input', triage);
    },
});
